export const environment = {
  production: false,
  apiAdminUrl: 'https://back-admin-dev.gmallsys.app/',
  appAdminUrl: 'https://admin-dev.gmallsys.app',
  apiAppUrl: 'https://back-app-dev.gmallsys.app/',
  consumeOffer: '/offer/consume',
  eventManagement: '/event_management',
  consumeTicket: '/consume_ticket'
};
